module.exports = __webpack_public_path__ + "img/bt.ca472ce7.png";